module.exports = __webpack_public_path__ + "img/bg_function05_1_t.9d10537d.svg";